import { ButtonBase, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { Gateway } from '../../types/gateway'
import useStyles from './styles/GatewayTable.styles'

interface GatewayRowDesktopProps {
  data: Gateway
  hasAccessToViewGateway: boolean | undefined
}
const GatewayRowDesktop: React.FC<GatewayRowDesktopProps> = ({
  data,
  hasAccessToViewGateway
}) => {
  const classes = useStyles()

  return (
    <ButtonBase
      className={classes.tableRow}
      component={LocalizedLink}
      to={
        hasAccessToViewGateway
          ? `/gateway/${data.basicDetails.gatewayId}/details`
          : ''
      }>
      <div>
        <Typography className={classes.textRow}>
          {data.basicDetails.name}
        </Typography>
      </div>
      <div>
        <Typography className={classes.textRow}>
          {data.credential.gatewaysType}
        </Typography>
      </div>
      <div>
        <Typography className={classes.textRow}>
          {getTranslate(data.basicDetails.entityType)}
        </Typography>
      </div>
      <div>
        <Typography className={classes.textRow}>
          {data.basicDetails.entity}
        </Typography>
      </div>
    </ButtonBase>
  )
}
export default GatewayRowDesktop
